var map = {
	"./docblock.js": "./src/transformers/docblock.js",
	"./markdown.js": "./src/transformers/markdown.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;



//////////////////
// WEBPACK FOOTER
// ./src/transformers nonrecursive .js$
// module id = 91
// module chunks = 0 1 2 3 4 5 6 7